export const shared = {
  warning: "Advarsel",
  error: "Feil",
  info: "Informasjon",
  help: "Hjelp",
};
